// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2l84N","label":"styles_label__3rpw-"};